module.exports = __webpack_public_path__ + "img/turbo_on.a498f88d.png";